import AppImage from '@theme/components/atom/AppImage'
import AppTitle from '@theme/components/atom/AppTitle'
import ProductBox from '@theme/components/product/ProductBox'
import ProductBoxMixin from '~/mixins/ProductBoxMixin'

export default {
  mixins: [ProductBoxMixin],
  components: {
    AppImage,
    AppTitle,
    ProductBox,
  },
  props: {
    product: Object,
  },
  data() {
    return {
      headingLevel: 2,
    }
  },
}
